import { render, staticRenderFns } from "./activeCalendar.vue?vue&type=template&id=54f0845c&scoped=true"
import script from "./activeCalendar.vue?vue&type=script&lang=js"
export * from "./activeCalendar.vue?vue&type=script&lang=js"
import style0 from "./activeCalendar.vue?vue&type=style&index=0&id=54f0845c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f0845c",
  null
  
)

export default component.exports